import { render, staticRenderFns } from "./MCLUSTERDownload.vue?vue&type=template&id=23453c07&scoped=true&"
import script from "./MCLUSTERDownload.vue?vue&type=script&lang=js&"
export * from "./MCLUSTERDownload.vue?vue&type=script&lang=js&"
import style0 from "./MCLUSTERDownload.vue?vue&type=style&index=0&id=23453c07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23453c07",
  null
  
)

component.options.__file = "MCLUSTERDownload.vue"
export default component.exports